import { painPoints } from '@/mocks/corporateData';
import { useTranslation } from 'react-i18next';

export default function PainPoints() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[900px] mx-auto px-8">
        <div className="text-center mb-14">
          {String(t('corporate.pain.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('corporate.pain.title')}
          </h2>
          {String(t('corporate.pain.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-5"></div>
          {String(t('corporate.pain.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[600px] mx-auto">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {painPoints.map((item, idx) => (
            <div
              key={idx}
              className="flex items-start gap-4 p-5 bg-background-100/60 border border-background-200/60"
            >
              <div className="w-9 h-9 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${item.icon} text-accent-500 text-lg`}></i>
              </div>
              <p className="text-[16px] text-foreground-800 tracking-[0.04em] leading-relaxed pt-0.5">
                {t(`corporate.pain.item${idx + 1}`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
